// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Link-module--cds--assistive-text--5f625";
export var cdsHideFeedback = "Link-module--cds--hide-feedback--183f5";
export var cdsShowFeedback = "Link-module--cds--show-feedback--82cb5";
export var cdsSkeleton = "Link-module--cds--skeleton--3f8bb";
export var cdsVisuallyHidden = "Link-module--cds--visually-hidden--388f6";
export var link = "Link-module--link--4bd2c";